import { AppBreadcrumbState } from './types';

export const createBreadcrumb = (label: string, link?: string): AppBreadcrumbState => ({ label, link });
